/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-form-value-provider-factory.ts to modify the generation of this file.

import { CookieValueProvider } from 'src/helpers/Forms/ValueProviders/Providers/CookieValueProvider';
import { JobContextValueProvider } from 'src/helpers/Forms/ValueProviders/Providers/JobContextValueProvider';
import { QueryStringValueProvider } from 'src/helpers/Forms/ValueProviders/Providers/QueryStringValueProvider';

const providers = new Map(); 

providers.set('cookievalueprovider',CookieValueProvider)
providers.set('jobcontextvalueprovider',JobContextValueProvider)
providers.set('querystringvalueprovider',QueryStringValueProvider)

import { IBaseValueProvider } from 'src/helpers/Forms/ValueProviders/BaseValueProvider';
import { FormFieldProps } from 'lib/forms';

/**
 * @function constructor
 * @param  providerFieldsProps: Foundation.EnterpriseWeb.Core.FieldSets.Forms.FieldValueProviderSettings['fields'] - current provider related fields
 */

 export function formValueProviderFactory(
  provider: FormFieldProps,
): IBaseValueProvider | undefined {

  const providerClass = providers.get(provider.templateName.replaceAll?.(' ', '').toLowerCase());

  if (!!providerClass)
    return new providerClass({
      providerFieldsProps: provider.fields,
    });

  console.error(`No provider handler defined for ${provider.templateName}`);
  
  return undefined;
};
